import { keys } from 'rambdax-v9';

export function extractCookies(cookiesStr: string): Record<string, string> {
  const container: Record<string, string> = {};

  const splitedOuter: string[] = cookiesStr.split(';');
  for (const innerStr of splitedOuter) {
    const splitedInner: string[] = innerStr.split('=');
    container[splitedInner[0].trim()] = splitedInner[1];
  }

  return container;
}

export function mapCookies(
  cookies: Record<string, string>,
  cookiesMap: Record<string, string>
): Record<string, string> {
  const container: Record<string, string> = { ...cookies };
  for (const key of keys(cookiesMap)) {
    if (cookies[key]) {
      container[key] = cookiesMap[key];
    }
  }
  return container;
}

/**
 * @see https://github.com/stevermeister/ngx-cookie-service/blob/master/projects/ngx-cookie-service/src/lib/cookie.service.ts
 */
export function setCookie(name: string, value: string, expires?: Date, path?: string, domain?: string): string {
  let cookieString: string = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';';
  if (expires) {
    cookieString += 'expires=' + expires.toUTCString() + ';';
  }
  cookieString += 'path=' + (path ?? '/') + ';';
  if (domain) {
    cookieString += 'domain=' + domain + ';';
  }
  return cookieString;
}
